import { render } from "./CrusadeTypeView.vue?vue&type=template&id=0fd51c02"
import script from "./CrusadeTypeView.vue?vue&type=script&lang=js"
export * from "./CrusadeTypeView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__